module.exports = __webpack_public_path__ + "static/media/08_tn.a9e8ea2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/08_tn.jpg
// module id = 497
// module chunks = 0